import { makeAutoObservable } from 'mobx';

export type Theme = 'light' | 'dark';

export class ThemeStore {
    theme: Theme = 'dark';

    constructor(initialTheme?: Theme) {
        makeAutoObservable(this);
        if (initialTheme) {
            this.theme = initialTheme;
        }
        // Initialize the data-theme attribute on the root element
        this.updateDomTheme();
    }

    setTheme(theme: Theme) {
        this.theme = theme;
        this.updateDomTheme();
        this.updatePendoUser();
    }

    toggleTheme() {
        this.theme = this.theme === 'light' ? 'dark' : 'light';
        this.updateDomTheme();
        this.updatePendoUser();
    }

    get isDarkMode(): boolean {
        return this.theme === 'dark';
    }

    get isLightMode(): boolean {
        return this.theme === 'light';
    }

    get inactiveTheme(): Theme {
        return this.theme === 'dark' ? 'light' : 'dark';
    }

    private updateDomTheme() {
        // Update the data-theme attribute on the document root element
        // This allows CSS variables to react to theme changes
        if (typeof document !== 'undefined') {
            document.documentElement.setAttribute('data-theme', this.theme);
        }
    }

    private updatePendoUser() {
        if (window.pendo?.isReady?.() && window.pendo?.updateOptions) {
            window.pendo.updateOptions({
                visitor: {
                    themePreference: this.theme,
                },
            });
        }
    }
}
